<ng-container *transloco="let t">
  <ng-template #issueSummary>
    <div class="flex flex-col">
      @if (rejectedAdCount() > 0) {
        <span>{{ t("creative-display.n_rejected_ads", { count: rejectedAdCount() }) }}</span>
      }
      @if (notCreatedAdCount() > 0) {
        <span>{{ t("creative-display.n_not_created_ads", { count: notCreatedAdCount() }) }}</span>
      }
    </div>
  </ng-template>

  @if (hasRejectedAds()) {
    <IAlert type="warning">
      <div class="flex items-center justify-between gap-2">
        <ng-container *ngTemplateOutlet="issueSummary" />
        <button iButton variant="secondary" class="-my-1" (click)="openRejectedAdsModal()">
          {{ t("common.details") }}
        </button>
      </div>
    </IAlert>
  } @else if (showFaultyReason()) {
    <IAlert type="warning">{{ faultyReason() }}</IAlert>
  }

  <ng-template #rejectedAdsModal>
    <div class="flex flex-col gap-4">
      <div class="type-body tracking-tight">
        <ng-container *ngTemplateOutlet="issueSummary" />
      </div>
      @for (ad of creativeIssues(); track ad) {
        <div class="flex flex-col gap-2 rounded-xl border p-4">
          @if (ad.reasonKey) {
            <app-creative-warning-detail-block [title]="t('creative-display.reason')">
              <div class="type-body text-foreground">{{ t(ad.reasonKey) }}</div>
            </app-creative-warning-detail-block>
          }
          @if (ad.bidderMessage) {
            <app-creative-warning-detail-block
              [title]="ad.amazonMessage ? t('creative-display.amazon_message') : t('common.details')"
            >
              <div class="type-body text-foreground">{{ ad.bidderMessage }}</div>
            </app-creative-warning-detail-block>
          }
          @if (ad.code) {
            <app-creative-warning-detail-block [title]="t('creative-display.error_code')">
              <IBadge [label]="ad.code" color="gray" variant="soft" size="xs" />
            </app-creative-warning-detail-block>
          }
          @if (ad.adIds && ad.adIds.length > 0) {
            <app-creative-warning-detail-block [title]="t('creative-display.ad_id')">
              <div class="type-body text-foreground">{{ ad.adIds.join(", ") }}</div>
            </app-creative-warning-detail-block>
          }
          @if (ad.description) {
            <app-creative-warning-detail-block [title]="t('common.description')">
              <div class="type-body text-foreground">{{ ad.description }}</div>
            </app-creative-warning-detail-block>
          }
          @if (ad.violatingType && ad.violatingType !== "UNKNOWN") {
            <app-creative-warning-detail-block [title]="t('creative-display.violating_type')">
              <IBadge [label]="ad.violatingType" color="gray" variant="soft" size="xs" />
            </app-creative-warning-detail-block>
          }
          @if (ad.violatingContent) {
            <app-creative-warning-detail-block [title]="t('creative-display.violating_content')">
              <div class="type-body text-foreground">
                @if (ad.violatingContent.startsWith("http")) {
                  <a class="link" [href]="ad.violatingContent" target="_blank">{{ ad.violatingContent }}</a>
                } @else {
                  {{ ad.violatingContent }}
                }
              </div>
            </app-creative-warning-detail-block>
          }
          @if (ad.asins && ad.asins.length > 0) {
            <app-creative-warning-detail-block [title]="t('creative-display.impacted_asins')">
              <div class="type-body text-foreground">{{ ad.asins.join(", ") }}</div>
            </app-creative-warning-detail-block>
          }
        </div>
      }
    </div>
  </ng-template>
</ng-container>
